import React, { useState, useRef } from 'react'
import Page from 'ui/page'
import LanguageSwitcher from 'ui/language_switcher'
import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody
} from 'reactstrap'
import parse from 'react-html-parser'
import styled from 'styled-components'
import Modal from 'ui/modal'
import SendProductInfoForm from 'containers/list/send_product_info_form'
import clientConfig from 'config/client_config.json'
import { useTranslation } from 'react-i18next'
import { scrollIntoView } from 'scroll-js'
import ProductDetails from './product_details'
import ResponsiveImage from 'ui/responsive_image'

const Styles = styled.div`
  h2 {
    font-size: 1.8em;
    font-weight: 300;
  }

  p.policy-text,
  .location-instructions > p {
    margin: 0;
  }

  strong {
    font-weight: bold;
  }

  .card-body img {
    width: 100%;
  }

  .navbar a {
    cursor: pointer;
    transition: 0.2s ease;

    &:hover {
      color: yellow !important;
    }
  }

  table th {
    background: #ddd;
  }

  table td,
  table th {
    border: 1px solid #ddd;
    padding: 5px 8px;
  }
`

const ProductInfo = (props) => {
  const { product, user, urls, language_links } = props
  const {
    title,
    featured_image_srcset,
    images_srcset
  } = product
  const { supportTelephone, supportEmail } = clientConfig
  const { i18n } = useTranslation()

  const descriptionRef = useRef()
  const detailsRef = useRef()
  const returnPolicyRef = useRef()
  const locationRef = useRef()

  const Topbar = () => (
    <Navbar color="dark" dark className="d-print-none mb-4 py-2">
      <Container className="d-flex flex-wrap justify-content-between align-items-center">
        {/* Lado izquierdo */}
        <Nav className="d-flex flex-wrap align-items-center">
          <NavItem className="me-4 mb-2 mb-md-0">
            <NavLink className="text-white" href={`tel:${supportTelephone}`}>
              <i className="fa fa-phone me-1" />
              {supportTelephone}
            </NavLink>
          </NavItem>
          <NavItem className="mb-2 mb-md-0">
            <NavLink className="text-white" href={`mailto:${supportEmail}`}>
              <i className="fa fa-envelope me-1" />
              {supportEmail}
            </NavLink>
          </NavItem>
        </Nav>

        {/* Lado derecho */}
        <Nav className="d-flex flex-wrap align-items-center justify-content-end">
          <NavItem className="me-3 mb-2 mb-md-0 p-2">
            <LanguageSwitcher en es fr urls={language_links} />
          </NavItem>
          <NavItem className="mx-2 mb-2 mb-md-0" onClick={() => window.print()}>
            <NavLink className="text-white">
              <i className="fa fa-print me-1" />
              {i18n.t('format:actions.print')}
            </NavLink>
          </NavItem>
          <NavItem className="mb-2 mb-md-0">
            <SendEmailLink />
          </NavItem>
        </Nav>
      </Container>
    </Navbar>
  )

  const SendEmailLink = () => {
    const [modal, setModal] = useState(false)
    const toggle = () => setModal(!modal)

    return (
      <>
        <NavLink className="text-white" onClick={toggle}>
          <i className="fa fa-envelope me-1" />
          {i18n.t('format:actions.send_email')}
        </NavLink>

        <Modal
          isOpen={modal}
          toggle={toggle}
          header={i18n.t('format:actions.send_email')}
          width="450px"
        >
          <SendProductInfoForm
            endpoint={urls.send_product_info}
            url={urls.info}
          />
        </Modal>
      </>
    )
  }

  const Footer = () => {
    const year = new Date().getFullYear()

    return (
      <Navbar color="dark" dark className="d-print-none mt-5 py-2">
        <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
          {/* Lado izquierdo */}
          <Nav className="d-flex flex-column flex-md-row align-items-center mb-2 mb-md-0">
            <NavItem className="me-md-4 mb-2 mb-md-0">
              <NavLink className="text-white" href={`tel:${supportTelephone}`}>
                <i className="fa fa-phone me-1" />
                {supportTelephone}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="text-white" href={`mailto:${supportEmail}`}>
                <i className="fa fa-envelope me-1" />
                {supportEmail}
              </NavLink>
            </NavItem>
          </Nav>

          {/* Lado derecho */}
          <Nav className="d-flex align-items-center">
            <NavItem>
              <NavLink className="text-white mb-0">
                Ticketinhotel © {year}
              </NavLink>
            </NavItem>
          </Nav>
        </Container>
      </Navbar>
    )
  }

  return (
    <Page {...props} headless>
      <Styles>
        <Topbar />
        <Container className="mb-3" style={{ fontSize: '1.18em' }}>
          <Row>
            <Col xs="12" md="8">
              <Card>
                <CardHeader className="bg-dark text-white text-center fw-bold">
                  {title}
                </CardHeader>
                <CardBody className="px-4 py-3">
                  {featured_image_srcset && (
                    <ResponsiveImage
                      src={featured_image_srcset}
                      alt={title}
                      className="mb-3 rounded"
                    />
                  )}
                  <ProductDetails {...props.product} />
                </CardBody>
              </Card>
            </Col>

            {images_srcset.length > 0 && (
              <Col xs="12" md="4">
                {images_srcset.map((image, i) => (
                  <ResponsiveImage
                    key={i}
                    src={image}
                    alt={`Imagen ${i + 1}`}
                    width="100%"
                    className="mb-3 img-thumbnail p-2 rounded"
                  />
                ))}
              </Col>
            )}
          </Row>
        </Container>

        <Footer />
      </Styles>
    </Page>
  )
}

export default ProductInfo
